// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3VuXz","label":"SetPasswdForm_label__3WJrJ"};